import Box from "@mui/material/Box";
import CssModule from "./404.module.less"
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  const navigate = useNavigate();
  return (
    <div className="privacy_page">
      <Box component="main" sx={{ p: 3 }} className={CssModule["error-page-wrapper"]}>
        <Box component="div" className={CssModule["error"]}>
          <Box component="div" className={CssModule["compartment"]}>
            <h1>Oops! Looks like you are lost in space!</h1>
            <Box component="div" className={CssModule["error-img-wrapper"]}>
              <img src={new URL(`@/assets/image/404-img.png`, import.meta.url).href} alt="404 Error" />
            </Box>
            <Box component="div" className={CssModule["bottom-error"]}>
              <p>The page you're looking for is out of our exosphere.</p>
              <a href="/">
                <button onClick={()=>navigate('/')} className={CssModule["error-but"]}>Let's take you back home</button>
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  )
}
